import axios, { AxiosError, InternalAxiosRequestConfig } from "axios";
import { auth, organisationStorage } from "../services/storage";
import { API_URL as API_BASE_URL, DEVICE_NAME } from "@/config/config";

// Create axios instance with platform-aware configuration
export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

// Request interceptor to add auth token and organisation ID
apiClient.interceptors.request.use(
  async (config: InternalAxiosRequestConfig) => {
    // Add Bearer token for all platforms
    const token = await auth.getToken();
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Add organisation ID header for scoped requests
    const currentOrg = await organisationStorage.getCurrentOrganisation();
    if (currentOrg && config.headers) {
      config.headers["X-Organisation-Id"] = currentOrg.id;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => response,
  async (error: AxiosError) => {
    if (error.response?.status === 401) {
      // Clear auth and organisation data on 401
      await auth.clearAuth();
      await organisationStorage.clearCurrentOrganisation();
      // The app will handle redirect through auth state
    }

    return Promise.reject(error);
  }
);

// Helper function to extract error message
export const getErrorMessage = (error: unknown): string => {
  if (axios.isAxiosError<{ message?: string; error?: string }>(error)) {
    if (error.response?.data) {
      const data = error.response.data;
      return data.message || data.error || "Er is een fout opgetreden";
    }
    return error.message;
  }
  return "Er is een onbekende fout opgetreden";
};

// Helper to get device name for API requests
export const getDeviceName = (): string => {
  return DEVICE_NAME;
};
